import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { FitnessCenter, TrackChanges, AttachMoney, Money } from '@material-ui/icons'
import { PageLevelTableWrapper, Table, TOAST_TYPE } from '@base'
import { strings } from '@constants'
import { getUsersMonthlyTarget } from '@data'
import { showLoader, showToast } from '@data/state/action'
import { CardDetail, MainWrapper, Wrapper } from '../CompanyReport'
import { displayAmount, displayWeight } from '@utils'

const OverallReport = () => {
	const [data, setData] = useState([])
	const [cardData, setCardData] = useState([])
	const dispatch = useDispatch()

	const getCardValue = (key, value) => {
		if (['total_monthly_target', 'total_target_achieved'].includes(key)) {
			return `${displayAmount(value)} Cr`
		} else if (key === 'total_pending_quantity_in_rupees') {
			return `${displayAmount(value / 10000000)} Cr`
		} else if (key === 'total_pending_quantity') {
			return `${displayWeight(value)}`
		} else {
			return value
		}
	}

	const getCardIcons = (key) => {
		switch (key) {
			case 'total_monthly_target':
				return <AttachMoney />
			case 'total_target_achieved':
				return <TrackChanges />
			case 'total_pending_quantity':
				return <FitnessCenter />
			case 'total_pending_quantity_in_rupees':
				return <Money />
			default:
				return <Money />
		}
	}

	useEffect(() => {
		dispatch(showLoader(true))
		getUsersMonthlyTarget()
			.then((response) => {
				setData(response?.user_target_details_list)
				setCardData(Object.entries(response?.total_targets).map(([key, value]) => ({ key, value })))
			})
			.catch((error) => {
				dispatch(showToast(true, strings('msg_data_not_fetched'), { type: TOAST_TYPE.ERROR }))
			})
			.finally(() => {
				dispatch(showLoader(false))
			})
	}, [])
	const columns = [
		{
			label: strings('full_name'),
			key: 'full_name',
			mobile: true,
		},
		{
			label: strings('region'),
			key: 'region',
			mobile: false,
		},
		{
			label: strings('manager', 'name'),
			key: 'manager_name',
			mobile: false,
		},
		{
			label: strings(['monthly_target']),
			// key: 'monthly_target',
			key: (data) => {
				return data
			},
			renderer: (data) => {
				return <div>{displayAmount(data?.monthly_target)}</div>
			},
			mobile: true,
		},
		{
			label: strings(['target_achieved']),
			key: (data) => {
				return data
			},
			renderer: (data) => {
				return (
					<div>
						<b>{displayAmount(data?.target_achieved) ?? '-'}</b>
						{data?.percentage !== null ? <span>{` (${data?.percentage}%)`}</span> : <></>}
					</div>
				)
			},
			mobile: true,
		},
		{
			label: strings(['order_book_cr']),
			key: (data) => {
				return data
			},
			renderer: (data) => {
				return (
					<div>
						<b>{displayAmount((data?.pending_quantity_in_rupees / 10000000).toFixed(2))}</b>
						<span>{` (${data?.pending_quantity}  MT)`}</span>
					</div>
				)
			},
			mobile: true,
		},
	]

	return (
		<>
			<Wrapper>
				<MainWrapper>
					{cardData?.map((item) => {
						return (
							<CardDetail
								heading={strings(item.key)}
								value={getCardValue(item?.key, item?.value)}
								hasDefinition={false}
								icon={getCardIcons(item?.key) ?? <Money />}
							/>
						)
					})}
				</MainWrapper>
			</Wrapper>
			<PageLevelTableWrapper>
				<Table fullHeight data={data} columns={columns} loading={false} rowClickable={false} hideFooter />
			</PageLevelTableWrapper>
		</>
	)
}

export default OverallReport
